import React from "react";

// Import components
import Modal from "../Modal/Modal";

const ChecklistModal = ({ openModal, setOpenModal }) =>
  openModal ? (
    <Modal>
      <div className="checklist-modal-container">
        <div className="checklist-modal">
          <div className="checklist-modal-header">
            <button
              aria-label="Close modal"
              onClick={() => {
                setOpenModal(false);
                window.scroll(0, 0);
              }}
              title="Close"
            >
              <i className="fa-regular fa-close" />
            </button>
            <h2>
              Thank you for submitting the <br />
              <i>Email Promotion Checklist</i>
            </h2>
          </div>
          <div className="checklist-modal-body">
            <p>
              We’ve sent you an email confirmation of your submission.
              <br />
              Our sales team will contact you shortly with next steps.
              <br />
              If you have any questions, reach out to us at{" "}
              <a href="mailto:sales@clinicallab.com">sales@clinicallab.com</a>
            </p>
          </div>
          <div className="checklist-modal-footer">
            <button
              type="submit"
              className="checklist-btn dark"
              onClick={() => {
                setOpenModal(false);
                window.scroll(0, 0);
              }}
            >
              CLOSE
            </button>
          </div>
        </div>
      </div>
    </Modal>
  ) : null;

export default ChecklistModal;
